import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import './Header.css';

import Logo from '../../assets/images/logo/xenvota-logo.svg';
import { getClientRoute } from '../../utils/appRoute';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const onHome = getClientRoute() === '/';
    if (!onHome) {
      window.location.href = `/#${sectionId}`;
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const goHome = () => {
    setIsMenuOpen(false);
    if (getClientRoute() === '/') {
      scrollToSection('hero');
      return;
    }
    window.location.href = '/';
  };

  const goToAboutPage = () => {
    setIsMenuOpen(false);
    window.location.href = '/#/about';
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="nav">
            <div className="nav-brand">
              <img src={Logo} alt="Xenvota" onClick={goHome} />
            </div>

            <div className="nav-menu">
              <button type="button" onClick={goToAboutPage} className="nav-link">
                About
              </button>
              <button type="button" onClick={() => scrollToSection('services')} className="nav-link">
                Services
              </button>
              <button type="button" onClick={() => scrollToSection('products')} className="nav-link">
                Our products
              </button>
              {/* <button onClick={() => scrollToSection('team')} className="nav-link">Team</button> */}
              <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            </div>

            <div className="nav-toggle" onClick={toggleMenu}>
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </div>
          </nav>
        </div>
      </header>

      {/* Mobile Menu - Outside the header */}
      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <button type="button" onClick={goToAboutPage} className="mobile-nav-link">
          About
        </button>
        <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Services</button>
        <button type="button" onClick={() => scrollToSection('products')} className="mobile-nav-link">
          Products
        </button>
        <button onClick={() => scrollToSection('team')} className="mobile-nav-link">Team</button>
        <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
      </div>
    </>
  );
};

export default Header; 